import React from "react";

const EndorsementLine = function EndorsementLine(props) {
    return (
        <div className="columns">
            <div className="column">
                {props.name}
            </div>
            <div className="column has-text-centered">
                {props.code}
            </div>
        </div>
    )
}

export default EndorsementLine;
